import { Heart } from 'lucide-react';
import { Icon } from '@zillow/constellation-10';

import { css } from '@/styled-system/css';

type FavoriteHeartIconProps = {
  selected: boolean;
};

export function FavoriteHeartIcon({ selected }: FavoriteHeartIconProps) {
  return (
    <Icon
      render={<Heart />}
      css={css.raw({
        fill: selected ? 'icon.favorite.fill' : 'none',
        stroke: selected ? 'icon.favorite.stroke' : 'currentColor',
        strokeWidth: 2,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      })}
    />
  );
}
